export default __webpack_public_path__ + "static/media/27Dimic.e2e0d6b6.jpg";